export const PasswordValidator = {
    isPasswordValid: (password: string): boolean => {
        return password && password.length > 7;
    }
};
